const video = () => {
    [].forEach.call(document.querySelectorAll('.video__poster'), (boton: HTMLButtonElement) => {
        const video = boton.closest('.video__contenedor')!.querySelector('video') as HTMLVideoElement;

        boton.addEventListener('click', () => {
            video.play();
            boton.classList.add('video__poster--oculto');
        });

        video.addEventListener('ended', () => {
            video.currentTime = 0;
            boton.classList.remove('video__poster--oculto');
        });

        video.addEventListener('pause', () => boton.classList.remove('video__poster--oculto'));
        video.addEventListener('play', () => boton.classList.add('video__poster--oculto'));
    });
}

export default video;